import { render, staticRenderFns } from "./ImportFile.vue?vue&type=template&id=4c7baadb&scoped=true&"
import script from "./ImportFile.vue?vue&type=script&lang=js&"
export * from "./ImportFile.vue?vue&type=script&lang=js&"
import style0 from "./ImportFile.vue?vue&type=style&index=0&id=4c7baadb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7baadb",
  null
  
)

export default component.exports